/**
 * localPVer2Api — RTK Query slice cho /purchase/local-p-ver2/list.
 * View tổng hợp Forward P + Top-up Alert.
 * Tag type: 'LocalPVer2'.
 */
import { baseApi } from './baseApi'
import type {
  LocalPVer2Item,
  LocalPVer2ListQuery,
  PageResponse,
} from '@/types/api'

export const localPVer2Api = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listLocalPVer2: b.query<PageResponse<LocalPVer2Item>, LocalPVer2ListQuery | void>({
      query: (params) => ({
        url: '/purchase/local-p-ver2/list',
        params: params ?? {},
      }),
      providesTags: (res) =>
        res
          ? [
              ...res.items.map((it) => ({
                type: 'LocalPVer2' as const,
                id: it.contract_no,
              })),
              { type: 'LocalPVer2' as const, id: 'LIST' },
            ]
          : [{ type: 'LocalPVer2' as const, id: 'LIST' }],
    }),
  }),
})

export const { useListLocalPVer2Query } = localPVer2Api
